<div>
    <div class="flex-end pointer-class" (click)="close()">
        <img src="/assets/icons/close-24px.svg" />
    </div>
    <h2 mat-dialog-title>
        {{ variantModalData.mode ? 'Edit' : 'Add' }} Set Variant <br /><span
            class="description"
            >{{ variantModalData.mode ? 'Edit' : 'Create' }} Set Variants, Add
            Colors, Sizes & Quantity</span
        >
        <hr />
    </h2>
    <div>
        <div class="dropdown-grid-list-container">
            <div class="dropdown-grid-list">
                <div class="dropdown-color-column">
                    <label class="dropdown-column-label">Color *</label>
                    <sp-multiselect-dropdown-chips
                        [options]="colors"
                        [optionPlaceHolder]="'color'"
                        [isColorType]="true"
                        (variantsDeletedEvent)="showDeletedAlert($event)"
                        (dropdownClosed)="onColorDropdownClicked($event)"
                    ></sp-multiselect-dropdown-chips>
                    <div
                        class="text"
                        *ngIf="showColorErrMsg && isColorDropdownClicked"
                    >
                        <span class="error-icon"
                            ><img src="/assets/icons/error-icon.svg"
                        /></span>
                        <span>Select at least 1 color option</span>
                    </div>
                </div>
                <div class="dropdown-size-column">
                    <label class="dropdown-column-label" *ngIf="!isApparelCategory">Size *</label>
                    <label class="dropdown-column-label" *ngIf="isApparelCategory">{{mapping[theme]}} *</label>

                    <sp-multiselect-dropdown-chips
                        [options]="sizes"
                        [optionPlaceHolder]="mapping[theme]"
                        (variantsDeletedEvent)="showDeletedAlert($event)"
                        (dropdownClosed)="onSizeDropdownClicked($event)"
                    ></sp-multiselect-dropdown-chips>
                    <div
                        class="text"
                        *ngIf="showSizeErrMsg && isSizeDropdownClicked"
                    >
                        <span class="error-icon"
                            ><img src="/assets/icons/error-icon.svg"
                        /></span>
                        <span>Select at least 1 {{mapping[theme]}} option</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="variant-grid-table">
            <sp-variant-grid-table
                (variantsDeletedEvent)="showDeletedAlert($event)"
                (variantsUpdatedEvent)="showUpdatedAlert($event)"
            ></sp-variant-grid-table>
        </div>
        <div class="variant-name-block">
            <p class="variant-name-label">Set Variant Name</p>
            <p class="variant-name" *ngIf="variantGridTableData.length">
                Set of {{ sumofQunatity }}
            </p>
            <p class="variant-name" *ngIf="!variantGridTableData.length">--</p>
        </div>
        <div class="modal-footer">
            <button
                mat-stroked-button
                class="delete-variant-btn"
                color="warn"
                *ngIf="variantModalData.mode"
                (click)="deleteSetVariants()"
            >
                Delete this Set
            </button>
            <button
                mat-button
                color="primary"
                class="btn-primary"
                [ngClass]="{
                    'active-btn': enableSaveBtn(),
                    'disabled-btn': !enableSaveBtn()
                }"
                (click)="saveSetVariants()"
            >
                Save {{ variantModalData.mode ? 'Changes' : 'Set Variant' }}
            </button>
        </div>
    </div>
    <div class="delete-alert-container">
        <sp-variant-delete-alert
            *ngIf="isVariantsDeleted"
            (closeDeleteAlert)="closeDeleteAlertAction()"
        ></sp-variant-delete-alert>
        <sp-variant-update-alert
            *ngIf="isVariantsUpdated"
            (closeDeleteAlert)="closeUpdateAlertAction()"
        ></sp-variant-update-alert>
    </div>
</div>
